<template>
  <el-dialog
    :title="clusterNodeDialog.type === 'edit' ? '编辑超边知识点' : '添加超边知识点'"
    :visible.sync="clusterNodeDialog.visible"
    width="600px"
    @close="clusterNodeDialogClose"
    @open="getListKnowledgeWithChapter"
  >
    <el-form :model="clusterNodeDialog.form" label-width="120px" :rules="clusterNodeRules" ref="clusterNodeFormRef">
      <el-form-item label="超边名称">
        {{ clusterNodeDialog.form.name }}
      </el-form-item>
      <el-form-item label="知识点" prop="knowledgeId">
        <el-cascader
          :options="newChapterListData"
          :props="cascaderProps"
          v-model="clusterNodeDialog.form.knowledgeId"
          placeholder="请选择"
          clearable
          :show-all-levels="false"
          style="width: 100%;"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="clusterNodeDialogClose">取消</el-button>
      <el-button type="primary" @click="clusterNodeSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { hyperedgeBindKnowledge, knowledgeWithChapter } from '@/request/api/knowledge_graph.js'

export default {
  name: 'KgClusterNodeDialog',
  inject: ['clusterNodeDialog', 'getknowledgeData', 'courseId'],
  data() {
    return {
      newChapterListData: [],
      cascaderProps: {
        emitPath: false,
        label: 'name',
        value: 'id',
      },
      clusterNodeRules: {
        knowledgeId: [{ required: true, message: '请选择知识点', trigger: 'change' }],
      },
    }
  },
  methods: {
    getListKnowledgeWithChapter() {
      knowledgeWithChapter({ courseId: this.courseId.value }).then(res => {
        if (res.code == 0 && res.data) {
          this.newChapterListData = this.transformStructure(res.data)
        }
      })
    },
    transformStructure(data) {
      // 构建三级结构：章 → 节 → 知识点
      return (data || []).map(function (chapter) {
        var chapterNode = {
          id: 'chapter_' + chapter.id,
          name: chapter.name,
          children: [],
        }
        var sections = chapter.chapters || chapter.children || []
        sections.forEach(function (section) {
          var sectionNode = {
            id: 'section_' + section.id,
            name: section.name,
            children: [],
          }
          var knowledges = section.knowledges || []
          knowledges.forEach(function (k) {
            sectionNode.children.push({ id: k.id, name: k.name })
          })
          if (sectionNode.children.length) {
            chapterNode.children.push(sectionNode)
          }
        })
        var chapterKnowledges = chapter.knowledges || []
        chapterKnowledges.forEach(function (k) {
          chapterNode.children.push({ id: k.id, name: k.name })
        })
        return chapterNode
      })
    },
    clusterNodeDialogClose() {
      this.clusterNodeDialog.visible = false
      this.clusterNodeDialog.type = 'add'
      this.clusterNodeDialog.form = { name: '', hyperedgeId: '', knowledgeId: '' }
    },
    clusterNodeSubmit() {
      this.$refs.clusterNodeFormRef.validate(valid => {
        if (valid) {
          var form = this.clusterNodeDialog.form
          hyperedgeBindKnowledge(form.hyperedgeId, [form.knowledgeId]).then(res => {
            if (res.code != 0) return this.$message.error(res.msg || '操作失败')
            this.$message.success('操作成功')
            this.clusterNodeDialogClose()
            this.getknowledgeData()
          })
        }
      })
    },
  },
}
</script>
